import Vue from "vue";
import VueRouter from "vue-router";
import { authRoutes } from "./authRoutes";
import { asyncRoutes } from "./asyncRoutes";
import NProgress from "nprogress";
import "nprogress/nprogress.css";
import { syncAppThemeForSession } from "@/utils/taskDashboardThemes";
import { OWNER_ALLOWED_ROUTES, USER_ROLES } from "@/utils/constants";

Vue.use(VueRouter);

NProgress.configure({
  showSpinner: false,
  easing: "ease",
  speed: 500,
  trickleSpeed: 100,
  template: `<div class="custom-progress bar" role="bar"><div class="peg"></div></div><div class="spinner" role="spinner"><div class="spinner-icon"></div></div>`
});

const router = new VueRouter({
  mode: "history",
  scrollBehavior: (to, from, savedPosition) => {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  },
  base: process.env.BASE_URL,
  routes: [...asyncRoutes, ...authRoutes]
});

router.beforeEach((to, _, next) => {
  NProgress.start();
  const isAuthenticated = localStorage.getItem("user-token");
  if (!isAuthenticated && to.matched.some(record => record.meta.requiresAuth)) {
    next({ name: "Login" });
    return;
  }

  // Owners are restricted to an allowlist rather than a denylist, so any
  // route added later stays closed to them until considered explicitly.
  // This blocks hand-typed URLs; the API enforces the same rules again.
  const isOwnerSession =
    localStorage.getItem("user-role") === USER_ROLES.OWNER;
  if (isOwnerSession && to.name && !OWNER_ALLOWED_ROUTES.includes(to.name)) {
    next({ name: "DedicatedCustomers" });
    return;
  }

  next();
});
router.afterEach(to => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    syncAppThemeForSession();
  }
  NProgress.done();
});
export default router;
